import { Typography } from '@mui/material';
import { FONT_SERIF, WD } from '../../../warningDashboard/warningTheme';
import { FIGURE, LEVEL_TONE } from '../utils/constants';
import Panel from './Panel';

/** One headline figure: label, number, and a line saying what it means. A level card is filled with that level's colour. */
export default function StatCard({ label, value, note, level }) {
  const tone = level ? LEVEL_TONE[level] : null;
  return (
    <Panel sx={{ p: 2, ...(tone && { bgcolor: tone.bg, borderColor: tone.accent }) }}>
      <Typography sx={{ fontSize: 12, fontWeight: 700, letterSpacing: '0.04em', textTransform: 'uppercase', color: tone ? tone.text : WD.inkMuted }}>
        {label}
      </Typography>
      <Typography component="div" sx={{ fontFamily: FONT_SERIF, fontSize: 32, fontWeight: 600, lineHeight: 1.15, mt: 0.5, color: tone ? tone.text : WD.ink, ...FIGURE }}>
        {value}
      </Typography>
      {note && <Typography sx={{ fontSize: 12, color: WD.inkMuted, mt: 0.25 }}>{note}</Typography>}
    </Panel>
  );
}
